import React from "react";
import "@/layout/AppLayout.css";

type AppLayoutProps = {
  sidebar: React.ReactNode;
  children: React.ReactNode;
};

export default function AppLayout({ sidebar, children }: AppLayoutProps) {
  return (
    <div className="layout-root">
      <div className="layout-body">
        <aside className="layout-sidebar">{sidebar}</aside>
        <main className="layout-chat">{children}</main>
      </div>
    </div>
  );
}
